import { isEmptyObject } from '@sky-it-livedata-libraries/livedata-commons';
import { SeasonRankingGalleryQuery } from '../types';

/**
 * typeguard for SeasonRankingGalleryQuery
 * @param SeasonRankingGalleryQuery object passed to transformer
 */
export const isValidSeasonRankingPage = (obj: SeasonRankingGalleryQuery): boolean => Boolean(obj?.data?.getSeasonRankingGalleryWidget && !isEmptyObject(obj.data.getSeasonRankingGalleryWidget));
